
export const ADMIN_GHOST_ACCOUNT_UID = 'a3407ce9-dd94-4f49-94bc-5ac301463881';

export const DEFAULT_SORTING_COLUMN = 'created_timestamp';


